import React from 'react'
import { Page, Document, StyleSheet, View, Text, Image } from '@react-pdf/renderer'
import Title from "../ContentLayout/Common/Title";
import { tableColumnStyle, htmlToStringDetail } from '../pdf_cst';

export default function ObjectsListingPDF ({data}) {
    const styles = StyleSheet.create({
        ...tableColumnStyle,
        row: {
            flexDirection: 'row',
            marginBottom: 32
        },
        titleContact : {
            flexDirection: 'column'

        },
        email : {
            textAlign: "center"
        },
        objectTitle: {
            fontSize: 16,
            marginBottom: 12
        },
        objectSubtitle: {
            fontSize: 12,
            marginBottom: 9
        },
        bigImage: {
            width: '100%', 
        },
        imagesContainer: {
            flexDirection: 'row',
            flexWrap: 'wrap'
        },
        imageContainer: {
            width: '33.3%',
            paddingRight: 8,
            paddingTop: 4,
            paddingBottom: 4
        }
    })

    return (
        <Document title={"Native-" + data.Title + ".pdf"}>
            <Page 
                size="A4" // {[595.28, 841.89]} 
                style={styles.page}
            >
                <View>
                    <Title title={"Native"}/>
                    <Text style={styles.objectTitle}>
                        {data.Title}
                    </Text>
                    <Text style={styles.objectSubtitle}>
                        {data.SubTitle}
                    </Text>
                    <Text>
                        {htmlToStringDetail(data.Description)}
                    </Text>
                    <View style={styles.imagesContainer}>
                        {data.OfficialImages?.[0] && data.OfficialImages.slice(0, 3).map((image) => (
                            <View key={image.ID} style={styles.imageContainer}>
                                <Image
                                  style={styles.bigImage}
                                  wrap={false}
                                  src={image.ImageUrl}
                                />
                            </View>
                        ))}
                    </View>
                </View>
                <Text
                    fixed
                    style={styles.BottomEmail}
                >
                    www.native-auctions.com
                </Text>
                <Text 
                    fixed
                    style={styles.PageNumber} 
                    render={({ pageNumber, totalPages }) => (
                        `${pageNumber} / ${totalPages}`
                    )} 
                />
            </Page>
        </Document>
    )
}